<template>
  <div class="main">
    <el-card
      v-loading="loading"
      class="box-card margin-b-20">
      <div v-if="!saved">
        <div class="resumen-container">
          <p class="encabezado margin-b-30"><strong>Verifica</strong> que los datos sean
          correctos y confirma la operación</p>

          <div class="margin-b-20 text-center bor-bottom resumen">
            <p>CLIENTE</p>
            <p>
              {{ order.clientName }}
            </p>
          </div>

          <div class="margin-b-20 text-center bor-bottom resumen">
            <p>CORREO</p>
            <p>
              {{ order.clientEmail }}
            </p>
          </div>

          <div class="margin-b-20 text-center bor-bottom resumen">
            <p>CÓDIGOS</p>
            <p
              v-for="(code, $index) in order.codes"
              :key="$index"
              class="codes">
              {{ code }}
            </p>
          </div>
        </div>
        <el-row :gutter="10">
          <el-col :span="12">
            <router-link :to="{name:'client'}">
              <el-button>Atrás</el-button>
            </router-link>
          </el-col>
          <el-col :span="12">
            <el-button
              type="primary"
              @click="confirm">Confirmar
            </el-button>
          </el-col>
        </el-row>
      </div>
      <div v-else>
        <p class="encabezado margin-b-40"><strong>La tarjeta ha sido activada con éxito.</strong></p>
        <div class="margin-b-20 text-center">
          <span class="circle"/>
        </div>
        <div class="margin-b-20 text-center validate-text">
          <p><b>¡IMPORTANTE!</b></p>
          <br>
          <p>Recuérdale a tu cliente <b>registrarse en el micrositio</b> de la Formula E para intercambiar sus códigos por boletos válidos de entrada.</p>
        </div>
        <el-row>
          <el-col :span="24">
            <router-link :to="{name:'invoice'}">
              <el-button type="primary">Finalizar</el-button>
            </router-link>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
import http from '@/services/http.service'

export default {
  name: 'SummaryForm',
  data () {
    return {
      loading: false,
      saved: false
    }
  },
  computed: {
    order () {
      return this.$store.getters['app/order']
    }
  },
  methods: {
    confirm () {
      this.loading = true
      http.post('orders', this.order).then(response => {
        this.saved = true
        this.$store.dispatch('app/clearOrder')
        this.loading = false
      }).catch(e => {
        console.log(e)
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.codes{
  font-size: 14px;
      color: #1482E1;
      margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/summary-form.vue